import React, { useState } from 'react';
import { LuEye, LuEyeOff } from 'react-icons/lu';

type PasswordToggleProps = {
  targetId: string;
  darkMode?: boolean; // Add darkMode prop
};

const PasswordToggle: React.FC<PasswordToggleProps> = ({ targetId, darkMode = false }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
    const passwordInput = document.getElementById(targetId) as HTMLInputElement;
    if (passwordInput) {
      passwordInput.type = isPasswordVisible ? 'password' : 'text';
    }
  };

  return (
    <>
      <button
        type="button"
        className={`absolute top-1/2 -translate-y-1/2 right-3.5 text-xl transition-colors focus:outline-none ${
          darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-700 hover:text-gray-900'
        }`}
        onClick={togglePasswordVisibility}
        style={{ display: isPasswordVisible ? 'none' : 'flex' }}
        aria-label="Show password"
      >
        <LuEye />
      </button>
      <button
        type="button"
        className={`absolute top-1/2 -translate-y-1/2 right-3.5 text-xl transition-colors focus:outline-none ${
          darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-700 hover:text-gray-900'
        }`}
        onClick={togglePasswordVisibility}
        style={{ display: isPasswordVisible ? 'flex' : 'none' }}
        aria-label="Hide password"
      >
        <LuEyeOff />
      </button>
    </>
  );
};

export default PasswordToggle;